var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UserService } from './../../services/user.service';
import { MatDialog, MatSidenav, MatIconRegistry, MatSnackBar } from '@angular/material';
import { OnInit, TemplateRef } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';
import { BorradoresComponent } from '../borradores/borradores.component';
import { crearBorradorComponent } from '../borradores/crearBorrador/crearBorrador.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import * as FormActions from '../../reducers/actions/forms.actions';
import * as FinalFormactions from '../../reducers/actions/form_final.actions';
import { SidenavService } from 'src/app/services/sidenav.service';
import { SolicitudesExpComponent } from '../solicitudesexp/solicitudesexp.component';
import { DomSanitizer } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import * as NotificationActions from '../../reducers/actions/notification.actions';
import { GLOBAL } from 'src/app/services/global';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormBuilder, Validators } from '@angular/forms';
import { ClaveUnicaService } from 'src/app/services/clave_unica.service';
import { RegistroComponent } from '../home/registro/registro.component';
import { rutClean } from 'rut-helpers';
var MainNavComponent = /** @class */ (function () {
    function MainNavComponent(_snackBar, breakpointObserver, dialog, storeN, _router, _userService, store, storeF, _sidenavService, matIconRegistry, domSanitizer, toastr, fb, spinner, claveUnicaService, route) {
        var _this = this;
        this._snackBar = _snackBar;
        this.breakpointObserver = breakpointObserver;
        this.dialog = dialog;
        this.storeN = storeN;
        this._router = _router;
        this._userService = _userService;
        this.store = store;
        this.storeF = storeF;
        this._sidenavService = _sidenavService;
        this.matIconRegistry = matIconRegistry;
        this.domSanitizer = domSanitizer;
        this.toastr = toastr;
        this.fb = fb;
        this.spinner = spinner;
        this.claveUnicaService = claveUnicaService;
        this.route = route;
        this.materias = [];
        this.isExpanded = true;
        this.showSubmenu = false;
        this.isShowing = false;
        this.showSubSubMenu = false;
        this.borradores = [];
        this.footer = GLOBAL.footer;
        this.web = GLOBAL.web;
        this.webUrl = GLOBAL.webUrl;
        this.nombreMuni = GLOBAL.nombreMuni;
        this.acotado = GLOBAL.acotado;
        this.isHandset$ = this.breakpointObserver.observe(Breakpoints.Handset)
            .pipe(map(function (result) { return result.matches; }));
        this.regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        this.matIconRegistry.addSvgIcon("obramenor", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/obramenor.svg'))
            .addSvgIcon("edificacion", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/edificacion.svg'))
            .addSvgIcon("subdivision", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/houses.svg'))
            .addSvgIcon("division", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/parquet.svg'))
            .addSvgIcon("copropiedad", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/profiles.svg'))
            .addSvgIcon("catastrofes", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/landslide.svg'))
            .addSvgIcon("antenas", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/antenna.svg'))
            .addSvgIcon("regularizacion", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/worker.svg'))
            .addSvgIcon("institucion", this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/permisos/fire-station.svg'));
        this.form = this.store.select('form');
        this.storeN.select('contador').subscribe(function (response) {
            _this.contador_definitivo = response.contador;
        }, function (error) {
            console.error(error);
        });
        localStorage.clear();
        sessionStorage.removeItem("borrador");
        this.getFormularios();
        this.mail = this.fb.group({
            email: ['', [Validators.pattern(this.regexp), Validators.required, Validators.maxLength(50)]],
        });
    }
    MainNavComponent.prototype.ngDoCheck = function () {
        this.expandedItem = sessionStorage.getItem("expandedItem");
    };
    MainNavComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (sessionStorage.getItem('identity-domCloud')) {
            this.searchUser();
            this.identity = this._userService.getIdentity();
            this.token = this._userService.getToken();
            var rut = this.identity.rut + this.identity.dv;
            this._userService.askForMail(rut).subscribe(function (response) {
                if (response.status == true) {
                    _this.dialog.open(_this.mailSave, { disableClose: true });
                    _this.spinner.hide();
                }
                else {
                    _this.spinner.hide();
                }
            }, function (error) {
                console.log(error);
                _this.spinner.hide();
            });
        }
        else {
            this._router.navigate(['/inicio']);
            swal({
                type: 'warning',
                text: "Para acceder a estos servicios, deberá iniciar sesión con su clave de sistema o su clave única.",
                showConfirmButton: true,
                confirmButtonText: 'Aceptar',
                allowOutsideClick: false
            });
        }
        this._sidenavService.setSidenav(this.sidenav);
    };
    MainNavComponent.prototype.verBorradores = function () {
        var formOptions = this.dialog.open(BorradoresComponent, {});
    };
    MainNavComponent.prototype.mouseenter = function () {
        if (!this.isExpanded) {
            this.isShowing = true;
        }
    };
    MainNavComponent.prototype.mouseleave = function () {
        if (!this.isExpanded) {
            this.isShowing = false;
        }
    };
    MainNavComponent.prototype.getFormularios = function () {
        var _this = this;
        this._userService.getFormularios().subscribe(function (response) {
            _this.materias = response.materias;
            console.log("response", response.materias);
        }, function (error) {
            console.log("main-nav.component.ts error", error);
        });
    };
    MainNavComponent.prototype.getForm = function (id, title, online) {
        var _this = this;
        if (online) {
            localStorage.clear();
            sessionStorage.removeItem('borrador');
            this.store.dispatch(new FormActions.FormUpdate(id, title));
            this.storeF.dispatch(new FinalFormactions.FinalFormCreate({
                newFormValues: {
                    formulario: '1.1',
                    tipo_solicitud: 'prueba',
                }
            }));
            setTimeout(function () {
                _this.storeF.dispatch(new FinalFormactions.FinalFormCreate({
                    newFormValues: {
                        proyectos: []
                    }
                }));
            }, 2000);
            if (this.acotado == true) {
                localStorage.setItem("form", '0.1');
                localStorage.setItem("formId", id);
                localStorage.setItem("formTitle", title);
            }
            else {
                localStorage.setItem("form", id);
            }
            setTimeout(function () {
                _this.sidenav.toggle(false);
            }, 200);
            this._userService.formMostUsed(id, title).subscribe(function (response) {
                console.log(response);
            }, function (error) {
                console.log('!!!!!!!!!!!!error formMostUsed', error);
            });
        }
        else {
            alert("El formulario seleccionado solo se puede realizar presencialmente");
        }
    };
    MainNavComponent.prototype.saveDraft = function () {
        this.dialog.open(crearBorradorComponent);
    };
    MainNavComponent.prototype.back = function () {
        this.store.dispatch(new FormActions.FormUpdate('0', ''));
        localStorage.clear();
        sessionStorage.removeItem('borrador');
        this._router.navigate(['/inicio']);
    };
    MainNavComponent.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.store.dispatch(new FormActions.FormUpdate('0', ''));
                        sessionStorage.removeItem("identity-domCloud");
                        sessionStorage.removeItem("token-domCloud");
                        return [4 /*yield*/, this.claveUnicaService.logoutClaveUnica()];
                    case 1:
                        response = _a.sent();
                        console.log('Deslogeo exitoso:', response);
                        this._snackBar.open("Se ha cerrado sesión", "Cerrar", {
                            duration: 3000,
                        });
                        this.back();
                        return [2 /*return*/];
                }
            });
        });
    };
    MainNavComponent.prototype.inicio = function () {
        this._router.navigate(['/']);
    };
    MainNavComponent.prototype.getSolicitudes = function () {
        this.dialog.open(SolicitudesExpComponent);
    };
    MainNavComponent.prototype.getSolic = function () {
        var _this = this;
        //console.log("Entre en los forms")
        this.notification_count = 0;
        var contador = 0;
        this._userService.getSolicitudes().subscribe(function (response) {
            for (var index = 0; index < response.length; index++) {
                var element = response[index];
                if (element.fieldData.Estado == 3 && (element.fieldData.Notificado == "" || element.fieldData.Notificado == null)) {
                    _this.notification_count++;
                }
                if (contador == (response.length - 1)) {
                    _this.storeN.dispatch(new NotificationActions.NotificationUpdate(_this.notification_count));
                    if (contador > 0 && _this.nombreMuni != 'Lo Barnechea') {
                        _this.toastr.warning('Pre-ingresos Rechazados', "Tienes " + _this.notification_count + " solicitude(s) de expediente rechazadas");
                    }
                }
                contador++;
            }
        }, function (error) {
            console.log("main-nav.component.ts error", error);
        });
    };
    MainNavComponent.prototype.submitMail = function () {
        var _this = this;
        this.spinner.show();
        var rut = this.identity.rut + this.identity.dv;
        console.log(this.mail.value.email);
        this._userService.saveNewMail(rut, this.mail.value.email).subscribe(function (response) {
            console.log(response);
            alert(response.message);
            _this.dialog.closeAll();
            _this.spinner.hide();
        }, function (error) {
            console.log(error);
            _this.spinner.hide();
        });
    };
    MainNavComponent.prototype.searchUser = function () {
        var _this = this;
        /* Buscar si existe en fm */
        var identityData = this._userService.getIdentity();
        var rut = identityData.rut + identityData.dv;
        this._userService.buscarUsuario(rutClean(rut)).subscribe(function (response) {
            if (response.message) {
                _this.spinner.hide();
                console.log(response);
            }
            if (response.register) {
                _this.spinner.hide();
                console.log(response);
                _this.dialog.open(RegistroComponent, {
                    id: "logindialog",
                    width: '50vw',
                    height: 'auto',
                    disableClose: true // Evita cerrar al hacer clic fuera (opcional)
                });
            }
        }, function (error) {
            var e = JSON.parse(error._body);
            _this.spinner.hide();
        });
    };
    return MainNavComponent;
}());
export { MainNavComponent };
